// ScheduleDateType values, hand-synched w/ PortCall.Models\Schedule\ScheduleDateEntity.cs.
export enum ScheduleDateType {
    IPArrival   = "IA",
    IPDeparture = "ID",
    PJOStart    = "PS",
    PJOEnd      = "PE",
}



// WEBPACK FOOTER //
// ./data/models/ScheduleDateType.ts